import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLine } from '../../../common/hooks';
import { ServicesTemplate } from '../template';

const ServicesPage = () => {
  const { idLine, idName } = useParams();

  // Hook que gestiona automáticamente la carga de la línea
  const { line } = useLine(idLine, idName);

  // Marcar que el usuario ha pasado por la página de services
  useEffect(() => {
    sessionStorage.setItem('hasVisitedServices', 'true');
  }, []);

  return (
    <ServicesTemplate
      line={line}
    />
  );
};

export default ServicesPage;
